'use client'

import { getCartItemsCountText } from '@dustin-web/microsite-baselayout/src/components/header/cart/mini-cart-utils'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'

const CartHeader = () => {
  const { cartItems } = useShoppingCart({
    withRequiredEndUserInformation: true,
  })

  const { translate } = useI18n()
  const numberOfProducts = cartItems.reduce((acc, curr) => acc + curr.quantity, 0)

  return (
    <h1 className={`h3 ${numberOfProducts > 0 ? 'u-mb-8' : 'u-mb-16'}`}>
      {getCartItemsCountText(numberOfProducts, translate)}
    </h1>
  )
}

export default CartHeader
